import React,{useState} from 'react';
import { useParams } from 'react-router-dom';
import { Button, Checkbox, FormControlLabel, IconButton, Tooltip } from '@material-ui/core';
import {Dialog,DialogActions,DialogContent,DialogTitle,TextField,Select,MenuItem,InputLabel } from '@material-ui/core';
import { Delete, Edit } from '@material-ui/icons';
import styled from 'styled-components';
import Row from '../Row';
import Column from '../Column';
import realtimeDB from '../../Utils/api';
import Input from '../Input';

const Container=styled.div`
margin:10px;
padding:15px;
border-radius: 20px;
box-shadow: rgb(154 160 185 / 75%) 0px 5px 10px, rgb(166 173 201 / 50%) 0px 15px 40px;`;

const NombreTag=styled.p`
text-align:center;`;

const DescripcionTag=styled.p`
margin:10px;
font-weight:600;`;


const ButtonIcon=({icon,label,onClick})=>
{
    return  <Tooltip title={label} >
        <IconButton onClick={onClick}>
        {icon}
        </IconButton>
    </Tooltip>
}

const ModalEdit=({variable,categoria,idProducto,open,close})=>
{
    const [Nombre, setNombre] = useState(variable.data.Nombre);
    const [Descripcion, setDescripcion] = useState(variable.data.Descripcion);
    const [Precio, setPrecio] = useState(variable.data.Precio);
    const [esPrecioPrincipal, setEsPrecioPrincipal] = useState(variable.data.esPrecioPrincipal)

    const guardarVariable=async ()=>
    {
        await realtimeDB.ref(`/Menu/CategoriasDOS/${categoria}/Items/${idProducto}/Variables/${variable.id}`).update(
        {
            Nombre,
            Descripcion,
            Precio,
            esPrecioPrincipal
        });
    }

    const CheckBotonConfirmarValido=()=>
    {
        if(Nombre==="" || Precio==="")
        {
            return true;
        }
        return false;
    }

    return <Dialog open={open} onClose={close}>
        <DialogTitle style={{textAlign:"center"}}>{variable.data.Nombre}</DialogTitle>
        <DialogContent>
            <div style={{margin:"10px 0"}}>
                <Column>
                    <Input label="Nombre" value={Nombre} changeValue={setNombre}/>
                    <Input label="Precio" type="number" value={Precio} changeValue={setPrecio}/>
                </Column>
            </div>
            <Input label="Descripción" value={Descripcion} changeValue={setDescripcion}/>
            <FormControlLabel control={<Checkbox checked={esPrecioPrincipal} onChange={e => setEsPrecioPrincipal(e.target.checked)} />} label="Precio principal"/>
        </DialogContent>
        <DialogActions>
            <Button color="primary" variant="outlined" onClick={close}>Cancelar</Button>
            <Button color="primary" variant="contained" onClick={guardarVariable} disabled={CheckBotonConfirmarValido()}>Confirmar</Button>
        </DialogActions>
    </Dialog>
}

const Variable = ({variable,idProducto}) =>
{
    const {id,data}=variable;
    const [editOpen, seteditOpen] = useState(false)
    const Params=useParams()

    const {Nombre,Descripcion,Precio,esPrecioPrincipal}=data;

    const deleteVariable=async()=>
    {
        console.log(Params)
       try
       {
            await realtimeDB.ref(`Menu/CategoriasDOS/${Params.categoria}/Items/${Params.id}/Variables/${id}`).remove();
       }
       catch(error)
       {
           console.log(error);
       }
    }

    return <Container props>
            <Column  custom={{display:"grid",gridTemplateColumns:"auto 15%",alignItems:"center"}}>
                <Row>
                    <NombreTag style={{fontWeight: esPrecioPrincipal ? "bold" : "inherit"}}>{Nombre} - ${Precio}</NombreTag>
                    <DescripcionTag>{Descripcion}</DescripcionTag>
                </Row>
                <div style={{justifySelf:"end"}}>
                    <ButtonIcon label="Editar" icon={<Edit/>} onClick={() => seteditOpen(true)}/>
                    <ButtonIcon label="Eliminar" icon={<Delete/>} onClick={deleteVariable}/>
                </div>
            </Column>
            <ModalEdit categoria={Params.categoria} idProducto={idProducto} variable={variable} open={editOpen} close={() => seteditOpen(false)}/>
        </Container>
}

export default Variable
